import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const headerWrapper = style({
  display: "flex",
  alignItems: "flex-start",
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      margin: "0 auto",
      width: "50%",
    },
  },
});

export const headerItem = style({
  position: "relative",
  display: "grid",
  flex: 1,
  justifyItems: "center",
  gap: vars.space.xs,
  selectors: {
    "&:not(:last-child)::after": {
      position: "absolute",
      insetInlineEnd: 0,
      borderInlineStart: vars.borders.outlineVariant,
      height: "100%",
      content: '""',
    },
  },
});

export const pointValue = style({
  padding: vars.space["2xs"],
  lineHeight: 1,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading["3xl"],
  fontWeight: 400,
});

export const itemHeading = style({
  fontSize: vars.fontSizes.heading.s,
});

export const playerInfoWrapper = style({
  display: "grid",
  gap: vars.space["2xs"],
  textAlign: "center",
});

export const subheading = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.l,
  fontWeight: 400,
});

export const points = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.s,
});

export const pointsContainer = style({
  borderRadius: vars.radii.m,
  minWidth: 80,
  height: 80,
});

export const overallWrapper = style({
  marginBottom: vars.space.m,
  textAlign: "center",
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      marginBottom: 0,
    },
  },
});
